document.addEventListener('DOMContentLoaded', function() {
    let btn_more = document.querySelector('.btn-float .container-btns .quantity-control-up');
    let btn_more_original = document.querySelector('.style-pdp-custom .product-qty .quantity-control-up');
    let btn_minus = document.querySelector('.btn-float .container-btns .quantity-control-down');
    let btn_minus_original = document.querySelector('.style-pdp-custom .product-qty .quantity-control-down');

    btn_more.addEventListener('click', function() {
        btn_more_original.click();
    });

    btn_minus.addEventListener('click', function() {
        btn_minus_original.click();
    });


    /* function scroll, para calcular la distancia del elemento .addtocart hasta el top del viewport de la pagina */
    let btn_add_to_cart = document.querySelector('.style-pdp-custom .product__section-details .product-add .AddtoCart ');
    window.addEventListener('scroll', function() {
        let distance = btn_add_to_cart.getBoundingClientRect().top;
        if (distance < 0) {
            document.querySelector('.btn-float').classList.add('show-cart');
        } else {
            document.querySelector('.btn-float').classList.remove('show-cart');
        }
    });

    const slider = tns({
        container: '.container-swatches',
        items: 3,
        loop: false,
        controlsContainer: '.custom-controls',
        nav: false,
        mouseDrag: true,
        responsive: {
            420: {
                items: 5
            },
            560: {
                items: 7
            },
            768: {
                items: 4
            },
            // Entre 1024 y 1280 el carril de swatches solo da para 4 celdas:
            // con 5 la ultima quedaba cortada por el overflow del slider.
            1024: {
                items: 4
            },
            1281: {
                items: 5
            },
            1441: {
                items: 7
            }
        }
    });

    const AnchroReview = document.querySelector('.product__section-details .yotpo');
    AnchroReview.addEventListener('click', function() {
        window.location.href = '#yotpo-app';
    });
});